import React, { memo } from "react";
import { Modal, Button } from "react-bootstrap";

import EcardPopupimg from "../../assets/card-pop-img.png";
import BgImage from "../../assets/card-pop-bg-img.png";

const AlertPopup = memo(
  ({
    show,
    onClose,
    title = "E-Cards Are Now Live!",
    facilities = [],
    confirmButtonText = "OK",
    onConfirm,
  }) => {
    return (
      <Modal
        show={show}
        centered
        backdrop="static"
        dialogClassName="custom-popup-modal"
      >
        <div className="popup-card">
          <div className="popup-header">
            <h2>{title}</h2>
          </div>

          <div
            className="popup-body"
            style={{ backgroundImage: `url(${BgImage})` }}
          >
            <div className="popup-flex">
              <img src={EcardPopupimg} alt="E-Card" className="popup-icon" />
              <p className="popup-title-text">
                Send digital cards to your loved ones.
              </p>
            </div>

            <p className="popup-subtext">
              E-Cards are available for the facilities listed below:
            </p>

            <div className="facility-flow">
              <div className="facility-list">
                {facilities?.map((facility, index) => (
                  <span key={index} className="facility-tag">
                    {facility}
                  </span>
                ))}
              </div>
            </div>

            <p className="popup-footer-text">Send your E-Card today!</p>

            <div className="popup-button-wrap">
              <Button
                className="ok-button"
                onClick={() => {
                  onConfirm && onConfirm();
                  onClose();
                }}
              >
                {confirmButtonText}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
);

export default AlertPopup;
